import styled from 'styled-components';
import { campoBase, rotuloFlutuante, rotuloFlutuanteAtivo } from '../../styles/campo';

export const Input = styled.input`
  ${campoBase}
`;

export const ContainerSugestoes = styled.ul`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 260px;
  overflow-y: auto;
  list-style: none;
  padding: ${({ theme }) => theme.espaco.xs} 0;
  background: ${({ theme }) => theme.cores.card};
  border: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: ${({ theme }) => theme.raio.md};
  box-shadow: ${({ theme }) => theme.sombra.dropdown};
  z-index: ${({ theme }) => theme.zIndex.dropdown};
`;

export const Sugestao = styled.li`
  padding: 10px 12px;
  cursor: pointer;
  color: ${({ theme }) => theme.cores.ink};
  text-align: left;

  &:hover {
    background: ${({ theme }) => theme.cores.surface};
  }
`;

export const Container = styled.div`
  position: relative;
  width: 100%;

  label {
    ${rotuloFlutuante}
  }

  input:not(:placeholder-shown) + label,
  input:focus + label {
    ${rotuloFlutuanteAtivo}
  }

  input:focus + label {
    color: ${({ theme }) => theme.cores.primary};
  }
`;
